<template>
  <form
    class="flex w-full flex-col space-y-6"
    @submit="onSubmit"
  >
    <FormInputPassword
      v-if="requireCurrentPassword"
      autocomplete="current-password"
      label="Current Password"
      name="currentPassword"
    />

    <FormInputPassword
      autocomplete="new-password"
      label="New Password"
      name="password"
    />
    <FormInputPassword
      autocomplete="new-password"
      label="Confirm Password"
      name="confirmPassword"
    />

    <div class="flex items-center justify-between">
      <router-link
        v-if="requireCurrentPassword"
        :to="{ name: 'passwordResetRequest' }"
        class="text-sm text-primary hover:text-primary/70"
      >
        Forgot password?
      </router-link>

      <div v-else />

      <FormSubmitButton class="ml-auto">
        {{ submitLabel }}
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import {
  useSetChangeResetPasswordForm,
  type SetChangeResetPasswordFormInput,
  type SetChangeResetPasswordFormOutput,
} from "@/composables/forms/useSetChangeResetPasswordForm"
import { type SubmissionContext } from "vee-validate"

const props = defineProps<{
  requireCurrentPassword: boolean
}>()

const submitLabel = computed(() =>
  props.requireCurrentPassword
    ? "Update Password"
    : "Set Password"
)

const emit = defineEmits<{
  (
    event: "submit",
    params: SetChangeResetPasswordFormOutput,
    context: SubmissionContext<SetChangeResetPasswordFormInput>
  ): void
}>()

const { handleSubmit } = useSetChangeResetPasswordForm()

const onSubmit = handleSubmit(async (values, context) => {
  emit("submit", values, context)
})
</script>
